import React from 'react';
import CoreLink from '../../components/core_link';
import Breadcrumbs from '../../components/breadcrumbs';

export interface BreadcrumbData {
  type?: string;
  position?: number;
  linkText: string;
  path: string;
}

export interface IProps {
  breadcrumbs: Array<BreadcrumbData>;
}

function getSortedBreadcrumbs(breadcrumbs: Array<BreadcrumbData>) {
  const breadcrumbTypeOrder = [
    'brand',
    'productType',
    'modelFamily',
    'subFamily',
    'series',
    'artist',
  ];
  return breadcrumbs.sort(
    (a, b) => {
      if (a.type && b.type) {
        return breadcrumbTypeOrder.indexOf(a.type) - breadcrumbTypeOrder.indexOf(b.type);
      }

      if (a.type) {
        return (breadcrumbTypeOrder.indexOf(a.type) + 1) - b.position;
      }

      if (b.type) {
        return a.position - (breadcrumbTypeOrder.indexOf(b.type) + 1);
      }

      return a.position - b.position;
    });
}

function Breadcrumb(props: { breadcrumb: BreadcrumbData, idx: number }) {
  return (
    <>
      {!props.breadcrumb.path && <span itemProp="name">{props.breadcrumb.linkText}</span>}
      {props.breadcrumb.path &&
        <CoreLink to={ props.breadcrumb.path } itemProp="item">
          <span itemProp="name">{props.breadcrumb.linkText}</span>
        </CoreLink>}
      <meta itemProp="position" content={`${props.idx + 1}`} />
    </>
  );
}

export default function BreadcrumbNavigation(props: IProps) {
  const { breadcrumbs } = props;
  if (!breadcrumbs.length) return null;

  return (
    <div className="cms-heading__breadcrumbs">
      <Breadcrumbs>
        {getSortedBreadcrumbs(breadcrumbs).map(
          (b, idx) =>
            !!b.linkText &&
            <Breadcrumb breadcrumb={b} idx={idx} key={b.type} />,
        )}
      </Breadcrumbs>
    </div>
  );
}
